import request from '../axios/fetch'
let baseUrl;
let tokenUrl;
let fdfsUrl;
let shareUrl;
let searchCode;
let socketUrl;
let financialUrl
if(location.host === 'h5.mogugu.com'){
  baseUrl = 'https://code.mogugu.com';
  tokenUrl = 'https://sr.mogugu.com'; 
  fdfsUrl = 'https://fdfs.mogugu.com/';
  shareUrl = 'https://' + location.host;
  searchCode = 'searchEnterprise2'
  socketUrl = 'ws://spring.mogugu.com'
  financialUrl='https://' + location.host+'/news';
}else{
  fdfsUrl = 'https://rdt.fdfs.modgo.pro/';
  baseUrl = 'https://rdt.modgo.pro';
  tokenUrl = 'https://rdt.sr.modgo.pro';
  shareUrl = 'https://' + location.host;
  searchCode = 'searchEnterprise'
  socketUrl = 'ws://' + location.host
  financialUrl='https://wxpay.modgo.pro/news'
}
// let ur = 'https://code.mogugu.com'
export function searchEnterprise2(params) {
  if (location.host === 'h5.mogugu.com') {
    console.log('prod')
    return request({
      url: baseUrl+'/code/searchEnterprise2',
      method: 'get',
      params
    })
  } else {
    return request({
      url: baseUrl+'/code/searchEnterprise',
      method: 'get',
      params
    })
  }
}

export function checkEnterpriseName(params) {
  console.log('checkName')
  return request({
    url: baseUrl + '/code/checkEnterpriseName',
    method: 'get',
    params
  })
}

export function downloadSystemInputReport(params) {
  console.log('checkName')
  return request({
    url: baseUrl + '/code/downloadSystemInputReport',
    method: 'get',
    params
  })
}

export function getWebReportImageUrl(params) {
  console.log('checkName')
  return request({
    url: baseUrl + '/code/getWebReportImageUrl',
    method: 'get',
    params
  })
}


export function loginMobileNumber (params) {
  return request({
    url: tokenUrl + '/token/code/login-mobileNumber',
    method: 'post',
    params
  })
}

export function synchronizedValReportInfo(params){
  return request({
    url: baseUrl + '/rdt/synchronizedValReportInfo',
    method: 'get',
    params
  })
}

export function sendSMSReportInfo(params){
  return request({
    url: baseUrl + '/rdt/sendSMSReportInfo',
    method: 'get',
    params
  })
}

export function getSignature(params){
  return request({
    // url: 'https://rdt.h5.mogugu.com'+ '/code/getSignature',
    url: shareUrl + '/code/getSignature',
    method: 'get',
    params
  })
}

export function getValTerminalByCode(params) {
  return request({
    // url: 'https://rdt.h5.mogugu.com'+ '/code/getSignature',
    url: baseUrl + '/code/getValTerminalByCode',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js